// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var OrganizationGoal = function (x) {
    return x;
};
var tsBridgeOrganizationGoal = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("OrganizationGoal")("__brandOrganizationGoal"));
    }
};
var writeOrganizationGoal = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showOrganizationGoal = Data_Show.showString;
var readOrganizationGoal = Simple_JSON.readString;
var ordOrganizationGoal = Data_Ord.ordString;
var newtypeOrganizationGoal = {
    Coercible0: function () {
        return undefined;
    }
};
var makeOrganizationGoal = OrganizationGoal;
var eqOrganizationGoal = Data_Eq.eqString;
export {
    OrganizationGoal,
    makeOrganizationGoal,
    unwrap,
    newtypeOrganizationGoal,
    eqOrganizationGoal,
    ordOrganizationGoal,
    showOrganizationGoal,
    readOrganizationGoal,
    writeOrganizationGoal,
    tsBridgeOrganizationGoal
};
//# sourceMappingURL=index.js.map
